import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class RecurringServicesTableRowCtrl implements IController {
  service: any
  isSelected: boolean;
  isExpended: boolean;
  enableAccountColumn: boolean;
  toggle: Function;
  onExpand: Function;
  onEdit: Function;
  onDuplicate: Function;
  onRemove: Function;

  private configZoneId: any;

  /* @ngInject */
  constructor(private $delivery, private $mdMedia, private splitService) {
    this.configZoneId = this.splitService.getTimeZone();
  }

  $onInit() {
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  checkBoxClick() {
    this.toggle({serviceId: this.service.id});
  }

  onBeforeExpand() {
    const hasRelations = _.some(this.service.taskList, (t) => {
      return t.relations && t.relations.length;
    });
    if (hasRelations) {
      this.onExpand({serviceId: this.service.id});
    }
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('recurringServicesTableRow', {
    bindings: {
      service: '<',
      isSelected: '<',
      isExpended: '<',
      enableAccountColumn: '<?',
      toggle: '&',
      onExpand: '&',
      onEdit: '&',
      onDuplicate: '&',
      onRemove: '&'
    },
    template: require('./recurring-services-table-row.html').default,
    controller: RecurringServicesTableRowCtrl
  });
